import { useDispatch } from 'react-redux'
import { trackInternalEvent } from '@rio/tracking'
import { useTypedSelector } from 'builder/hooks/useTypedSelector'
import { actions } from 'builder/modules/resumeEditor'
import { FetchStatuses } from 'builder/modules/constants'
import { useRemainingAiResumeReviewFreeAttempts } from 'builder/hooks/useRemainingAiResumeReviewFreeAttempts'
import { ReviewFullSectionWrapper } from './styles'
import { AiResumeReviewWelcomeStep } from './components/AiResumeReviewWelcomeStep/AiResumeReviewWelcomeStep'
import { AiResumeReviewLoader } from './components/AiResumeReviewLoader/AiResumeReviewLoader'
import { AiResumeReviewError } from './components/AiResumeReviewError/AiResumeReviewError'
import { AiResumeReviewResult } from './components/AiResumeReviewResult/AiResumeReviewResult'

export const AiResumeReview = () => {
  const reviewResult = useTypedSelector(state => state.resumeEditor.aiResumeReview.reviewResult)
  const fetchStatus = useTypedSelector(state => state.resumeEditor.aiResumeReview.fetchStatus)
  const dispatch = useDispatch()
  const remainingAttempts = useRemainingAiResumeReviewFreeAttempts()

  const handleStartReview = () => {
    if (remainingAttempts > 0) {
      trackInternalEvent('click_get_better', {
        label: 'ai_review_tab',
      })
      dispatch(actions.startAiResumeReview())
    } else {
      dispatch(actions.setIsAiResumeReviewPaywallModalOpen(true))
    }
  }

  const renderContent = () => {
    if (fetchStatus === FetchStatuses.loading) {
      return <AiResumeReviewLoader />
    }

    if (fetchStatus === FetchStatuses.failed) {
      return <AiResumeReviewError onRetry={handleStartReview} />
    }

    if (!reviewResult) {
      return <AiResumeReviewWelcomeStep onStartReview={handleStartReview} />
    }

    return <AiResumeReviewResult data={reviewResult} onRefresh={handleStartReview} />
  }

  return (
    <ReviewFullSectionWrapper data-testid="ai-resume-review-container">
      {renderContent()}
    </ReviewFullSectionWrapper>
  )
}
